import { CheckBox } from 'bricks-ui/packages/bricks-ui';

export default CheckBox;
